module.exports = __webpack_public_path__ + "static/15th-d6ae184dcd069136e29bd6c355ba7ea8.png";